import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'

export enum WayFilterOperation {
  Equals = 'equals',
  NotEquals = 'notEquals',
  Exists = 'exists',
  DoesNotExist = 'doesNotExist',
}

export interface IWayFilterPostBody {
  operation: WayFilterOperation
  key: string
  value?: string
}

export interface IWayFilterPatchBody extends Partial<IWayFilterPostBody> {}

export interface IWayFilterResponse extends IModelJsonValues {
  operation: WayFilterOperation
  key: string
  value: string | null
}

export interface IListWayFilterQueryParams extends IListModelQueryParamValues {}
